
const headers = token => ({
	headers: {
		Authorization: token ? ('Bearer ' + token) : null,
		Accept: 'application/json'
	}
})

export const companyIndex = access_token => {
	return new Promise((resolve, reject) => {
		axios.get('/api/companies', headers(access_token))
			.then(res => resolve(res.data))
			.catch(err => reject(err.response))
	})
}

export const companyStore = (data, access_token) => {
	return new Promise((resolve, reject) => {
		axios.post('/api/companies', data, headers(access_token))
			.then(res => resolve(res.data))
			.catch(err => reject(err.response))
	})
}

export const companyShow = (id, access_token) => {
	return new Promise((resolve, reject) => {
		axios.get(`/api/companies/${id}`, headers(access_token))
			.then(res => resolve(res.data))
			.catch(err => reject(err.response))
	})
}

export const companyByUser = access_token => {
	return new Promise((resolve, reject) => {
		axios.get('/api/companies/by-user', headers(access_token))
			.then(res => resolve(res.data))
			.catch(err => reject(err.response))
	})
}

export const companyUpdate = (id, data, access_token) => {
	return new Promise((resolve, reject) => {
		axios.put(`/api/companies/${id}`, data, headers(access_token))
			.then(res => resolve(res.data))
			.catch(err => reject(err.response))
	})
}

export const companyDelete = (id, access_token) => {
	return new Promise((resolve, reject) => {
		axios.delete(`/api/companies/${id}`, headers(access_token))
			.then(res => resolve(res.data))
			.catch(err => reject(err.response))
	})
}

export const getIndustries = () => {
	return new Promise((resolve, reject) => {
		axios.get(`/api/companies/industries`)
			.then(res => resolve(res.data))
			.catch(err => reject(err.response))
	})
}

export const getBusinessTypes = id => {
	return new Promise((resolve, reject) => {
		axios.get(`/api/companies/industry/${id}/business-types`)
			.then(res => resolve(res.data))
			.catch(err => reject(err.response))
	})
}
